const POverviewBlock = document.querySelector('.studentPopulationOverview-block');
if (POverviewBlock) {
    const totalCount = Number(POverviewBlock.getAttribute('data-count'));

    const economicBlock = POverviewBlock.querySelector('.studentLowIncome');
    const learningBlock = POverviewBlock.querySelector('.StudentCountSpecialEducation');
    const englishBlock = POverviewBlock.querySelector('.StudentCountEnglish');
    const transferRateBlock = POverviewBlock.querySelector('.MobilityRatePct');

    const economicData = Number(economicBlock.getAttribute('data-count'));
    const learningData = Number(learningBlock.getAttribute('data-count'));
    const englishData = Number(englishBlock.getAttribute('data-count'));
    const transferRateData = Number(transferRateBlock.getAttribute('data-count'));


    
    // Calculate the percentages
    const economicPercent = ((economicData / totalCount) * 100).toFixed(1);
    const learningPercent = ((learningData / totalCount) * 100).toFixed(1);
    const englishPercent = ((englishData / totalCount) * 100).toFixed(1);
    const transferRatePercent = transferRateData.toFixed(1);

    // Optionally, set these percentages as text or attributes in the DOM if needed
    economicBlock.querySelector('.value').innerHTML = `${economicPercent}%`;
    learningBlock.querySelector('.value').innerHTML =`${learningPercent}%`;
    englishBlock.querySelector('.value').innerHTML = `${englishPercent}%`;
    transferRateBlock.querySelector('.value').innerHTML = `${transferRatePercent}%`;

    const economicCircleBlock = economicBlock.querySelector('.progress-circle');
    const learningCircleBlock = learningBlock.querySelector('.progress-circle');
    const englishCircleBlock = englishBlock.querySelector('.progress-circle');
    const transferRateCircleBlock = transferRateBlock.querySelector('.progress-circle');

    // Convert percentages to degrees
    const economicDegree = Number(economicPercent) * 3.6;
    const learningDegree = Number(learningPercent) * 3.6;
    const englishDegree = Number(englishPercent) * 3.6;
    const transferRateDegree = Number(transferRatePercent) * 3.6;

  
    console.log('transferRateData: ', typeof transferRateData, (transferRateData / totalCount) * 100)
    economicCircleBlock['style'].setProperty('--degree', `${economicDegree}deg`);
    economicCircleBlock.classList.add('economic');
    economicCircleBlock.classList.add('play');

    learningCircleBlock['style'].setProperty('--degree', `${learningDegree}deg`);
    learningCircleBlock.classList.add('learning');
    learningCircleBlock.classList.add('play');

    englishCircleBlock['style'].setProperty('--degree', `${englishDegree}deg`);
    englishCircleBlock.classList.add('english');
    englishCircleBlock.classList.add('play');

    transferRateCircleBlock['style'].setProperty('--degree', `${transferRateDegree}deg`);
    transferRateCircleBlock.classList.add('transfer');
    transferRateCircleBlock.classList.add('play');
    
}